import React from 'react';

var Home = function Home(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.045C9 14.395 10.176 13 12 13s3 1.39 3 3.045V19h1.995c.562 0 1.005-.438 1.005-.971v-6.94c0-.267-.212-.772-.41-.968l-4.874-4.828a1.023 1.023 0 0 0-1.432 0L6.41 10.12c-.2.198-.41.697-.41.968v6.94c0 .535.441.971 1.005.971H9v-2.955zM7.005 21C5.344 21 4 19.676 4 18.029v-6.94c0-.807.424-1.817 1.003-2.39l4.873-4.827a3.023 3.023 0 0 1 4.248 0L18.997 8.7c.577.57 1.003 1.588 1.003 2.39v6.939C20 19.67 18.657 21 16.995 21H13v-4.955c0-.55-.303-1.045-1-1.045-.697 0-1 .501-1 1.045V21H7.005z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Home.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Home as icon };
export default iconHandler(Home);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Home.js
// module id = 602
// module chunks = 0